import { EditReason } from '@modules/charts/components/ChartTooltipWrapper/ChartTooltipActions/EditReason';
import { Divider, List } from '@mui/material';
import { AddToFilter } from './AddToFilter';
import { MergeWithAnotherReason } from './MergeWithAnotherReason';
import { ViewFeedback } from './ViewFeedback';

export function ChartTooltipActions() {
  return (
    <List disablePadding>
      <Divider component="li" />
      <AddToFilter />
      <ViewFeedback />
      <MergeWithAnotherReason />
      <EditReason />
    </List>
  );
}
